export default "__VITE_ASSET__Dzrott3p__"